import emptySplitApi from "../utils/rtk";
import { CommonBody, OfferLetterUsers } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
};
type GetUserResponse = {
  length: number;
  start: number;
  response_object: OfferLetterUsers[];
  total_records: number;
  from_date?: string;
  to_date?: string;
};

export const offerLetterApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    minPaymentUsers: builder.mutation<
      CommonResponseType & { data: GetUserResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.minPaymentUsers,
        method: "POST",
        body,
      }),
    }),
    sendOfferLetter: builder.mutation<
      CommonResponseType & { data: GetUserResponse },
      { body: CommonBody; id: number | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.sendOfferLetter}${id}/`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useMinPaymentUsersMutation, useSendOfferLetterMutation } =
  offerLetterApi;
